import React from "react"

export function Filter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      {...props}
    >
      <path
        d="M0.106498 0.626172C0.286966 0.243359 0.669779 0 1.09361 0H12.9061C13.3299 0 13.7127 0.243359 13.8932 0.626172C14.0737 1.00898 14.019 1.46016 13.751 1.78828L8.74986 7.89961V11.375C8.74986 11.7059 8.56392 12.0094 8.26587 12.157C7.96783 12.3047 7.61509 12.2746 7.34986 12.075L5.59986 10.7625C5.37837 10.5984 5.24986 10.3387 5.24986 10.0625V7.89961L0.245951 1.78555C-0.0192835 1.46016 -0.0767054 1.00625 0.106498 0.626172Z"
        fill="currectColor"
      />
    </svg>
  )
}
